<template>
<div class="chapter">
<div class="inner_page">
<p class="part4"><a id="page_xviii"></a><a id="page_xix"></a>Acknowledgements</p>
<p class="part5">to the New Edition</p>
<p class="nonindent">The following foundations and individuals gave generous support for the publication of this volume and volumes 8, 9, and 10 of <em>The Churchill Documents</em>: the Lynde and Harry Bradley Foundation, Milwaukee, Wisconsin; the Earhart Foundation, Ann Arbor, Michigan; the late George B. Ferguson, Peoria, Arizona; Mr. and Mrs. Thomas N. Jordan, Jr., Healdsburg, California; Mr. and Mrs. Tim M. Roudebush, Lenexa, Kansas; Mr. and Mrs. Emil A. Voelz, Jr., Akron, Ohio; and the Saul N. Silbert Charitable Trust, Sun City, Arizona.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?f2764f1c